import { cn } from '@repo/lib/cn';
import { questionLongTextSchema } from '@repo/schemas/quiz/questionLongText';
import { CircleAlertIcon } from 'lucide-react';

import { QuestionContentFormField } from '@/components/features/quiz/question/question-builder';
import { Form, FormControl, FormField, FormItem, FormMessage } from '@/components/ui/form';
import { FormLabel } from '@/components/ui/form/Form';
import { NumberInputVertical } from '@/components/ui/input';
import { useQuestionLongForm } from '@/hooks/questions';
import { questionsLabel } from '@/lib/questions-labels';
import { formErrorToast } from '@/utils/form';

import type { QuestionLongFormProps } from '.';

export function QuestionLongForm(questionLongFormProps: QuestionLongFormProps) {
  const { data, onSubmit = () => {}, className, ...props } = questionLongFormProps;

  const { form } = useQuestionLongForm(data);

  return (
    <Form {...form}>
      <form {...props} noValidate onSubmit={form.handleSubmit(onSubmit, () => formErrorToast(form, questionLongTextSchema))} className={cn('h-full', className)}>
        <div className="divide-border-primary divide-y">
          <QuestionContentFormField />
          <div className="space-y-6 p-3">
            <div className="text-muted-foreground flex items-center gap-1 text-xs">
              <CircleAlertIcon className="size-4" />
              <p>{data?.type && questionsLabel[data.type].builderDesc}</p>
            </div>
            <fieldset className="flex flex-col gap-3">
              <FormField
                name={'minLength'}
                render={({ field }) => (
                  <FormItem className="max-w-60">
                    <FormLabel>Min</FormLabel>
                    <FormControl>
                      <NumberInputVertical
                        {...field}
                        min={0}
                        value={field.value ?? undefined}
                        onChange={(value) => {
                          field.onChange(value ?? null);
                        }}
                        placeholder={'np.100'}
                      />
                    </FormControl>
                    <FormMessage />
                  </FormItem>
                )}
              />
              <FormField
                name={'maxLength'}
                render={({ field }) => (
                  <FormItem className="max-w-60">
                    <FormLabel>Max</FormLabel>
                    <FormControl>
                      <NumberInputVertical
                        {...field}
                        min={0}
                        value={field.value ?? undefined}
                        onChange={(value) => {
                          field.onChange(value ?? null);
                        }}
                        placeholder={'np.1000'}
                      />
                    </FormControl>
                    <FormMessage />
                  </FormItem>
                )}
              />
            </fieldset>
          </div>
        </div>
      </form>
    </Form>
  );
}
